import React, { useContext } from 'react';
import { useFavourites } from '../services/propertyFinderFavourites';

const PropertyFinderFavouritesContext = React.createContext(null);

export function PropertyFinderFavouritesContextProvider({ children }) {
  const {
    data: favourites = [],
    isLoading: isFavouritesLoading,
    refetch: reloadFavourites,
    error: favouritesError
  } = useFavourites();

  return (
    <PropertyFinderFavouritesContext.Provider
      value={{
        favourites,
        isFavouritesLoading,
        reloadFavourites,
        favouritesError
      }}
    >
      {children}
    </PropertyFinderFavouritesContext.Provider>
  );
}

export function usePropertyFinderFavourites() {
  const context = useContext(PropertyFinderFavouritesContext);

  if (!context) {
    throw new Error(
      'usePropertyFinderFavourites must be used within a PropertyFinderFavouritesContextProvider'
    );
  }

  return context;
}
